export default __webpack_public_path__ + "static/media/Decofix-Logo.5f49a0eb.webp";